import { render, staticRenderFns } from "./additionalPrescriptionDialog.vue?vue&type=template&id=6613f6e6&scoped=true"
import script from "./additionalPrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./additionalPrescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./additionalPrescriptionDialog.less?vue&type=style&index=0&id=6613f6e6&prod&lang=less&scoped=true&external"
import style1 from "./additionalPrescriptionDialog.vue?vue&type=style&index=1&id=6613f6e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613f6e6",
  null
  
)

export default component.exports